module.exports = __webpack_public_path__ + "app/kiss-order/grid-2SXjgnDf.html";